var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "camera-box" }, [
    !_vm.isIE
      ? _c("video", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.imgSrc,
              expression: "!imgSrc",
            },
          ],
          attrs: {
            id: "video",
            width: _vm.videoWidth,
            height: _vm.videoHeight,
          },
        })
      : _vm._e(),
    _vm.isIE
      ? _c("div", {
          style: { "z-index": _vm.cameraZindex },
          attrs: { id: "camera" },
        })
      : _vm._e(),
    _c("div", { staticClass: "video_bg_wrapper" }, [
      _c("img", {
        staticClass: "img_border",
        attrs: { src: require("@/assets/img/camera/border.png") },
      }),
      _c("img", {
        staticClass: "img_user",
        attrs: { src: require("@/assets/img/camera/user.png") },
      }),
      _c("img", {
        staticClass: "img_scan",
        attrs: { src: require("@/assets/img/camera/scan.png") },
      }),
      _c("p", [_vm._v("请确保您的面部全部显示在识别区域")]),
    ]),
    _c("canvas", {
      attrs: { id: "canvas", width: _vm.videoWidth, height: _vm.videoHeight },
    }),
    _vm.imgSrc
      ? _c("img", {
          staticStyle: { "z-index": "10000" },
          attrs: { src: _vm.imgSrc, id: "img" },
        })
      : _vm._e(),
    _c(
      "div",
      { staticClass: "btn_wrapper" },
      [
        !_vm.imgSrc
          ? _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.setImage },
              },
              [_vm._v(_vm._s(_vm.imgSrc ? "重新拍照" : "拍照"))]
            )
          : _vm._e(),
        _vm.imgSrc
          ? _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.resSetImage },
              },
              [_vm._v("重新拍照")]
            )
          : _vm._e(),
        _vm.imgSrc
          ? _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.setFileUpload },
              },
              [_vm._v("上传")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }